import { useCallback, useContext, useEffect, useState } from 'react';
import ButtonIconGhostSmall from '../../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import SelectionLayerDesign from '../SelectionLayerDesign/SelectionLayerDesign';
import RightPaletteMenu from '../RightPaletteMenu/RightPaletteMenu';
import ButtonSecondaryLarge from '../../../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import { DesignerPageContext } from '../../DesignerPage';
import { useDispatch, useSelector } from 'react-redux';
import RightPaletteDoorMenu from '../RightPaletteDoorMenu/RightPaletteDoorMenu';
import SelectedModel from '../SelectedModel/SelectedModel';
import { InsideType } from '../../../../constants/enum';
import RightKitchenEquipmentDesignMenu from '../RightKitchenEquipmentDesignMenu/RightKitchenEquipmentDesignMenu';
import RightPaletteGlassDoorMenu from '../RightPaletteGlassDoorMenu/RightPaletteGlassDoorMenu';
import RightLegMenu from '../RightLegMenu/RightLegMenu';
import RightPaletteLouveredWallMenu from '../RightPaletteLouveredWallMenu/RightPaletteLouveredWallMenu';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../../components/common/Tooltip/Tooltip';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import RightTextileShoeLowerBench from '../RightTextileShoeLowerBench/RightTextileShoeLowerBench';
import RightPaletteAlumDoorMenu from '../RightPaletteAlumDoorMenu/RightPaletteAlumDoorMenu';
import RightPaletteBedFlapMenu from '../RightPaletteBedFlapMenu/RightPaletteBedFlapMenu';
import { convertForeignCurrency } from '../../../../utils/currency/currency.utils';

const RightMaterialMenu = ({ open, onClose, title, selectedType }) => {
  const {
    showCabinetEditor,
    setShowCabinetEditor,
    cabinetType,
    // textureFrame,
    selectedModels,
    selectedModel,
    sceneManager,
    setOpenRightDoorAccessoryDesignMenu,
    setOpenRightLiftSupportDesignMenu,
  } = useContext(DesignerPageContext);

  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState();
  const [items, setItems] = useState([]);
  const [showKitchenEquipment, setShowKitchenEquipment] = useState(false);

  useEffect(() => {
    if (!open) {
      setSelectedItem(null);
    }
  }, [open, selectedType]);

  const getKitchenEquipmentTabName = type => {
    switch (type) {
      case InsideType.ACCESSORY_GENERAL:
        return t('Kitchen Accessories');
      case InsideType.ACCESSORY_DISH_UPPER:
        return t('Upper Dish Rack');
      case InsideType.ACCESSORY_DISH_LOWER:
        return t('Lower Dish Rack');
      case InsideType.ACCESSORY_SINK:
        return t('Sink');
      case InsideType.ACCESSORY_FAUCET:
        return t('Faucet');
      case InsideType.ACCESSORY_COOKER:
        return t('Cooktop');
      case InsideType.ACCESSORY_HOOD:
        return t('Hood');
      default:
        return t('Kitchen Equipment');
    }
  };

  const getMaterialDescription = material => {
    let description = null;
    if (material === 'L') description = 'Moisture-resistant MDF';
    else if (material === 'M') description = 'Melamine-coated MDF';
    else description = material;
    return description;
  };

  useEffect(() => {
    if (selectedModels.length) {
      const temp = [];
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      if (modules) {
        const moduleEntries = Array.from(modules.entries());
        const module = moduleEntries?.find(
          ([item, value]) => value.group.uuid === selectedModels[0].uuid
        );
        if (module) {
          const [item, value] = module;
          let doorTypes = [];
          value.listInside?.forEach(item => {
            if (item.type === InsideType.DOOR) {
              if (!doorTypes.includes(item.materialType ?? 'tron')) {
                doorTypes.push(item.materialType ?? 'tron');
              }
            }
          });

          // Kiểm tra tất cả cửa trong module có thể sử dụng Acrylic không
          const canUseAcrylic = value.listInside
            ?.filter(item => item.type === InsideType.DOOR)
            .every(item => item.useAcrylic || item.gltf?.userData?.useAcrylic);

          //KHUNG
          const textureFrame = value?.textures?.get('frame');

          temp.push({
            type: 'cabinet',
            name: t('Frame'),
            property: [
              {
                material: t(
                  getMaterialDescription(textureFrame?.material) || '--'
                ),
                name: textureFrame?.textureCode ?? t('Not selected'),
                src: textureFrame?.textureUrl,
              },
            ],
            open: false,
            actions: [],
            onClick: null,
          });

          if (doorTypes.length) {
            doorTypes.forEach(doorType => {
              //CỬA
              const textureDoor =
                value?.textures?.get('DOOR') ||
                value?.textures?.get(InsideType.DOOR);
              const textureDoorAlum = value?.textures?.get('DOOR-ALUM');
              const specialMaterial = ['nhom'].some(item =>
                doorType?.includes(item)
              )
                ? doorType
                : null;

              if (specialMaterial) {
                temp.push({
                  type: 'door',
                  name: t('Aluminum'),
                  property: [
                    {
                      material: t(
                        getMaterialDescription(textureDoorAlum?.material) ||
                          '--'
                      ),
                      name: textureDoorAlum?.textureCode ?? t('Not selected'),
                      src: textureDoorAlum?.textureUrl,
                      specialMaterial,
                      canUseAcrylic: !!canUseAcrylic,
                      doorType,
                    },
                  ],
                  open: false,
                  actions: [],
                  onClick: null,
                });
              } else {
                temp.push({
                  type: 'door',
                  name: t('Door'),
                  property: [
                    {
                      material: t(
                        getMaterialDescription(textureDoor?.material) || '--'
                      ),
                      name: textureDoor?.textureCode ?? t('Not selected'),
                      src: textureDoor?.textureUrl,
                      canUseAcrylic: !!canUseAcrylic,
                      doorType,
                    },
                  ],
                  open: false,
                  actions: [],
                  onClick: null,
                });
              }

              if (['kinh', 'vom'].some(item => doorType?.includes(item))) {
                //KÍNH CỬA
                const textureGlass = value?.textures?.get('GLASS-PANEL');
                temp.push({
                  type: 'glass',
                  name: t('Glass'),
                  property: [
                    {
                      material: ``,
                      name: textureGlass?.textureCode ?? t('Not selected'),
                      src: textureGlass?.textureUrl,
                    },
                  ],
                  open: false,
                  actions: [],
                  onClick: null,
                });
              }
            });
          }

          if (
            ['tv'].some(item => value?.moduleType?.includes(item)) &&
            ['lower'].some(item => value?.moduleType?.includes(item))
          ) {
            const leg = value?.listInside?.find(item =>
              [InsideType.KHUNG_SAT, InsideType.CHAN_ROI_TV].includes(item.type)
            );

            temp.push({
              type: 'leg',
              name: t('Cabinet legs'),
              property: [
                {
                  material: getValueFromString(
                    leg?.material || leg?.materialType
                  ),
                  price: convertForeignCurrency(Number(leg?.price ?? 0)),
                  name: leg?.name ?? t('Default'),
                  src: leg?.thumbnail_url ?? '/assets/images/leg_default.png',
                },
              ],
              open: false,
              actions: [],
              onClick: null,
            });
          }

          if (
            ['vach_lam', 'vach_guong', 'vach_tron'].some(item =>
              value?.moduleType?.includes(item)
            )
          ) {
            //VÁCH LAM
            const textureLouveredWall =
              value?.textures?.get('VACH-LAM') ??
              value?.textures?.get('VACH-TRON') ??
              value?.textures?.get('VACH-GUONG');

            const name = ['vach_lam'].some(item =>
              value?.moduleType?.includes(item)
            )
              ? 'Louvered wall'
              : ['vach_tron'].some(item => value?.moduleType?.includes(item))
                ? 'Plain wall'
                : ['vach_guong'].some(item => value?.moduleType?.includes(item))
                  ? 'Mirrored wall'
                  : 'Louvered wall';

            temp.push({
              type: 'vach_lam',
              name: t(name),
              property: [
                {
                  material: textureLouveredWall?.supplier?.name ?? '--',
                  name: textureLouveredWall?.textureCode ?? t('Not selected'),
                  src: textureLouveredWall?.textureUrl,
                },
              ],
              open: false,
              actions: [],
              onClick: null,
            });
          }
          if (
            ['shoe_lower_bench'].some(item => value?.moduleType?.includes(item))
          ) {
            //ĐÔN NGỒI
            const textureShoeLowerBench =
              value?.textures?.get('shoe_lower_bench');

            temp.push({
              type: 'shoe_lower_bench',
              name: t('Shoe lower bench'),
              property: [
                {
                  material: textureShoeLowerBench?.supplier?.name ?? '--',
                  name: textureShoeLowerBench?.textureCode ?? t('Not selected'),
                  src: textureShoeLowerBench?.textureUrl,
                },
              ],
              open: false,
              actions: [],
              onClick: null,
            });
          }
          // if (['bed'].some(item => value?.moduleType?.includes(item))) {
          //   //GIƯỜNG NGỦ
          //   const textureBedFlap = value?.textures?.get('vat_giuong');

          //   temp.push({
          //     type: 'vat_giuong',
          //     name: t('Bed flap'),
          //     property: [
          //       {
          //         material: textureBedFlap?.supplier?.name ?? '--',
          //         name: textureBedFlap?.textureCode ?? t('Not selected'),
          //         src: textureBedFlap?.textureUrl,
          //       },
          //     ],
          //     open: false,
          //     actions: [],
          //     onClick: null,
          //   });
          // }

          let handle = value?.listInside?.filter(
            item => item.type === InsideType.HANDLE
          );
          handle = handle.reduce((prev, curr) => {
            const existing = prev.find(item => item.type === curr.type);
            const temp = [...prev];
            if (!existing) {
              temp.push({ ...curr, quantity: 1 });
            } else {
              const index = temp.findIndex(item => item.type === curr.type);
              temp[index] = { ...curr, quantity: existing.quantity + 1 };
            }
            return temp;
          }, []);

          if (handle?.length) {
            temp.push({
              type: 'handle',
              name: t('Handle'),
              property: [
                ...handle.map(item => ({
                  ...item,
                  id: item._id,
                  src: item.thumbnail_url,
                  price: null,
                  material: getValueFromString(
                    item.material ?? 'Số lượng: ' + item.quantity
                  ),
                })),
              ],
              open: false,
              actions: [],
              onClick: () => setOpenRightDoorAccessoryDesignMenu(true),
            });
          }

          let liftSupport = value?.listInside?.filter(
            item => item.type === InsideType.LIFT_SUPPORT
          );
          liftSupport = liftSupport.reduce((prev, curr) => {
            const existing = prev.find(item => item.type === curr.type);
            const temp = [...prev];
            if (!existing) {
              temp.push({ ...curr, quantity: 1 });
            } else {
              const index = temp.findIndex(item => item.type === curr.type);
              temp[index] = { ...curr, quantity: existing.quantity + 1 };
            }
            return temp;
          }, []);

          if (liftSupport?.length) {
            temp.push({
              type: 'liftSupport',
              name: t('Lift Support'),
              property: [
                ...liftSupport.map(item => ({
                  ...item,
                  id: item._id,
                  src: item.thumbnail_url,
                  price: null,
                  material: getValueFromString(
                    item.material ?? 'Số lượng: ' + item.quantity
                  ),
                })),
              ],
              open: false,
              actions: [],
              // onClick: () => setOpenRightLiftSupportDesignMenu(true),
            });
          }

          const kitchenEquipment = value?.listInside?.filter(item =>
            [
              InsideType.ACCESSORY_GENERAL,
              InsideType.ACCESSORY_DISH_UPPER,
              InsideType.ACCESSORY_DISH_LOWER,
              InsideType.ACCESSORY_SINK,
              InsideType.ACCESSORY_FAUCET,
              InsideType.ACCESSORY_COOKER,
              InsideType.ACCESSORY_HOOD,
            ].some(type => item.type === type)
          );

          if (kitchenEquipment?.length) {
            temp.push({
              type: 'kitchenEquipment',
              name: t('Kitchen equipment'),
              property: [
                ...kitchenEquipment.map(item => ({
                  ...item,
                  id: item._id,
                  src: item.thumbnail_url,
                  nameTab: getKitchenEquipmentTabName(item.type),
                  material:
                    item.material ?? convertForeignCurrency(item.price) ?? '--',
                })),
              ],
              open: false,
              actions: [],
              onClick: () => setShowKitchenEquipment(true),
            });
          }
          let wardrobeEquipment = value?.listInside?.filter(item =>
            [InsideType.CLOTHES_HANGER].some(type => item.type === type)
          );
          wardrobeEquipment = wardrobeEquipment?.reduce((prev, curr) => {
            const existing = prev.find(item => item.type === curr.type);
            const temp = [...prev];
            if (!existing) {
              temp.push({ ...curr, quantity: 1 });
            } else {
              const index = temp.findIndex(item => item.type === curr.type);
              temp[index] = { ...curr, quantity: existing.quantity + 1 };
            }
            return temp;
          }, []);

          if (wardrobeEquipment?.length) {
            temp.push({
              type: 'wardrobeEquipment',
              name: t('Wardrobe equipment'),
              property: [
                ...wardrobeEquipment.map(item => ({
                  ...item,
                  id: item._id,
                  src: item.thumbnail_url,
                  price: null,
                  material: 'Số lượng: ' + item.quantity,
                })),
              ],
              open: false,
              actions: [],
              // onClick: () => setShowKitchenEquipment(true),
            });
          }

          setItems([...temp]);
          const currentItem = temp.find(item => item.type === selectedType);
          if (selectedType && !selectedItem) {
            setSelectedItem({ ...currentItem, open: true });
          } else if (
            selectedType &&
            selectedItem?.type === selectedType &&
            currentItem?.property?.[0]?.canUseAcrylic !==
              selectedItem?.property?.[0]?.canUseAcrylic
          ) {
            setSelectedItem({ ...currentItem, open: selectedItem.open });
          }
        }
      }
    } else setSelectedItem(null);
  }, [selectedItem, open, selectedModels, showCabinetEditor]);

  useEffect(() => {
    setShowKitchenEquipment(false);
  }, [selectedModel]);

  const toggleSelectedItem = useCallback(() => {
    if (selectedItem) {
      setSelectedItem({ ...selectedItem, open: !selectedItem.open });
    }
  }, [selectedItem]);

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{
          content: 'flex flex-col items-start grow self-stretch',
          root: 'top-84',
        }}
        styles={{ content: { backgroundColor: '#F7F7F7' } }}
        header={
          <>
            <Tooltip title={title} placement="top">
              <span className="text-title-large truncate">{title}</span>
            </Tooltip>
            <span
              className="w-24 h-24 flex"
              style={{ cursor: 'pointer' }}
              onClick={onClose}
            >
              <Icon.ICClose />
            </span>
          </>
        }
        content={
          <>
            {['kitchen'].includes(cabinetType) &&
              selectedModels.length === 1 && (
                <div
                  key={1}
                  className="flex py-8 px-16 items-center gap-16 self-stretch bg-fills-white"
                >
                  <Tooltip title={title} placement="top">
                    <div className={'flex items-center w-full'}>
                      <ButtonSecondaryLarge
                        posIcon={<Icon.ICTuneColor />}
                        title={t('Advanced Customization')}
                        preIcon={<Icon.ICNavigateRight />}
                        style={{ borderColor: '#258FD2' }}
                        onClick={() => setShowCabinetEditor(true)}
                        className={'w-full'}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
            <div key={2} className="flex flex-col gap-8 p-8 self-stretch">
              {items?.map((item, i) => {
                return (
                  <SelectionLayerDesign
                    key={i}
                    title={getValueFromString(item.name)}
                    items={item.property}
                    actions={item.actions}
                    actived={false}
                    onClick={() => {
                      if (item.onClick) item.onClick();
                      setSelectedItem({ ...item, open: true });
                    }}
                  />
                );
              })}
            </div>
          </>
        }
      />
      <RightPaletteMenu
        open={selectedItem?.type === 'cabinet' && selectedItem?.open}
        onClose={() => toggleSelectedItem()}
        title={selectedItem?.name}
      />
      <RightPaletteLouveredWallMenu
        open={
          selectedItem?.type === 'vach_lam' &&
          items.some(item => item.type === 'vach_lam') &&
          selectedItem?.open
        }
        onClose={() => toggleSelectedItem()}
        title={selectedItem?.name}
      />
      <RightPaletteBedFlapMenu
        open={
          selectedItem?.type === 'vat_giuong' &&
          items.some(item => item.type === 'vat_giuong') &&
          selectedItem?.open
        }
        onClose={() => toggleSelectedItem()}
        title={selectedItem?.name}
      />
      <RightTextileShoeLowerBench
        open={
          selectedItem?.type === 'shoe_lower_bench' &&
          items.some(item => item.type === 'shoe_lower_bench') &&
          selectedItem?.open
        }
        onClose={() => toggleSelectedItem()}
        title={selectedItem?.name}
      />
      <RightPaletteDoorMenu
        open={
          selectedItem?.type === 'door' &&
          !selectedItem?.property?.[0]?.specialMaterial &&
          selectedItem?.open
        }
        onClose={() => toggleSelectedItem()}
        canUseAcrylic={selectedItem?.property?.[0]?.canUseAcrylic}
        doorType={selectedItem?.property?.[0]?.doorType}
        title={selectedItem?.name}
      />
      <RightPaletteAlumDoorMenu
        open={
          selectedItem?.type === 'door' &&
          selectedItem?.property?.[0]?.specialMaterial?.includes('nhom') &&
          selectedItem?.open
        }
        onClose={() => toggleSelectedItem()}
        title={selectedItem?.name}
      />
      <RightPaletteGlassDoorMenu
        open={selectedItem?.type === 'glass' && selectedItem?.open}
        onClose={() => toggleSelectedItem()}
        title={selectedItem?.name}
      />
      <RightLegMenu
        open={selectedItem?.type === 'leg' && selectedItem?.open}
        onClose={() => toggleSelectedItem()}
        title={selectedItem?.name}
      />
      <RightKitchenEquipmentDesignMenu
        open={showKitchenEquipment}
        onClose={() => {
          setShowKitchenEquipment(false);
          toggleSelectedItem();
        }}
        title={
          cabinetType === 'kitchen' ? t('Kitchen equipment') : t('Accessories')
        }
        types={[
          ...(selectedItem?.property
            ? selectedItem?.property.map(item => ({
                ...item,
                key: item.gltfUuid,
                id: item.id,
                group: item.group,
                label: item.nameTab,
              }))
            : []),
        ]}
      />
    </>
  );
};

export default RightMaterialMenu;
